import { createContext } from "react";
const clockRecordContext = createContext();
export default clockRecordContext;
